import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./ActivedocCard.css";
import { fonts, themes } from "../themes/themes";
import { check_user_permission } from "../configs/utils";
import { useAppSelector } from "../../infra/hooks";

interface ICustomEditCardProps {
  card_title?: string;
  card_subtitle?: string;
  card_height?: string;
  onClick?: () => void;
  isAddButton?: boolean;
}

const ActivedocCard: React.FC<
  React.PropsWithChildren<ICustomEditCardProps>
> = ({
  children,
  card_title,
  card_height,
  onClick,
  card_subtitle,
  isAddButton = true,
}) => {
  const auth_permissions = useAppSelector((state:any) => state.authPermissionSlice?.authPermission);
  return (
    <Box
      style={{
        width: "auto",
        padding: "1.75em",

        /* UI Properties */
        background: "#ffffff 0% 0% no-repeat padding-box",
        boxShadow: "0px 1px 2px #00000029",
        borderRadius: "15px",
        opacity: 1,

        maxHeight: card_height,
        height: "auto",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Grid
            item
            xs={6}
            style={{
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <Typography
              style={{
                color: themes.blackDefault,
                fontSize: fonts.header,
                fontWeight: "bold",
              }}
            >
              {card_title}
            </Typography>
            <Typography
              style={{
                color: themes.defaultIcon,
                fontSize: fonts.subtitle,
                fontFamily: fonts.fontFamily,
              }}
            >
              {card_subtitle}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {check_user_permission(auth_permissions,isAddButton,"add") && (
              <Box
                style={{
                  width: "42px",
                  height: "42px",
                  backgroundColor: "#7c0e6f",
                  boxShadow: "0px 5px 6px #00000061",
                  opacity: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "100%",
                  cursor: "pointer",
                }}
              >
                <i className="las la-plus icon" onClick={onClick} />
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Box className="scrollbar__class">{children}</Box>
    </Box>
  );
};

export default ActivedocCard;
